<template>
	<div class="izk-map">
		<Back title="校区地址"></Back>
		<div id="container" class="container">

		</div>
	</div>
</template>
<script>
	import Back from '../back/Back.vue';
	import {mapState} from 'vuex';

	export default{
	  name: 'Map',
	  components: {
	    Back
	  },
	  data(){
	    return {
	      url: 'https://api.map.baidu.com/geocoder?location='
	    }
	  },
	  computed: mapState({
	    city: state => state.home.city
	  }),
	  watch: {
	    city: {
	      handler: function(){
	        this.init();
	      }
	    },
	    deep: true
	  },
	  methods: {
	    init(){
	      let route = this.$route.query;

	      this.url += `${route.lat  },${  route.lng  }&output=html&src=http://dev-www.izhikang.com/h5/#/`;

	      let map = new BMap.Map('container');
	      let point = new BMap.Point(route.lng, route.lat);

	      map.centerAndZoom(point, 15);

	      let sContent = `${'<div class="izk-map-box hbox">' + '<div class="place flex">' + '<p class="title">'}${  route.school_name  }</p>` + `<p class="info">${  route.address  }</p>` + `</div>` + `<a href="${  this.url  }" class="btn vcbox" @click="lead">导航</a>` + `</div>`;

	      let infoWindow = new BMap.InfoWindow(sContent);

	      map.openInfoWindow(infoWindow, map.getCenter());
	    }
	  },
	  created(){
	    this.$store.commit('isShowHeader', {isShowHeader: false});
	    this.$store.commit('isShowFooter', {isShowFooter: false});
	  },
	  mounted(){

	    this.init();
	  }

	}
</script>
<style scoped>
	.container{
		width: 100%;
		height: 500px;
	}
</style>


// WEBPACK FOOTER //
// src/components/public/map/Map.vue